module.exports = __webpack_public_path__ + "img/card-row-left.7dcbc52f.svg";